<caremoni-dialog-template
    id="check-sheet-setting"
    [dialogTemplate]="dialogTemplate" 
    (closeModalHandler)="closeModal()">
    <div modal-body>
        <p-tabs value="0" (valueChange)="onSaucerLogChangeTab($event)">
            <p-tablist>
                <p-tab value="0" tabindex="1" 
                    [attr.dpad]="DpadZoneType.DIALOG" 
                    [attr.x-tab-dpad]="0" 
                    [attr.y-tab-dpad]="0"
                    [attr.x-dpad]="0" 
                    [attr.y-dpad]="0"
                    [attr.tab-dpad]="1">{{CHECKSHEETSETTINGDIALOG.DISPLAY_SETTING_NYUSHO}}</p-tab>
                <p-tab value="1" tabindex="2" 
                    [attr.dpad]="DpadZoneType.DIALOG" 
                    [attr.x-dpad]="1" 
                    [attr.y-dpad]="0"
                    [attr.x-tab-dpad]="1"
                    [attr.y-tab-dpad]="0"
                    [attr.tab-dpad]="2" class="border-tab">{{CHECKSHEETSETTINGDIALOG.DISPLAY_COLUMN}}</p-tab>
                <p-tab value="2" tabindex="3" 
                    [attr.dpad]="DpadZoneType.DIALOG" 
                    [attr.x-dpad]="2" 
                    [attr.y-dpad]="0"
                    [attr.x-tab-dpad]="2"
                    [attr.y-tab-dpad]="0"
                    [attr.tab-dpad]="3" class="border-tab">{{CHECKSHEETSETTINGDIALOG.SETTING_CONFIG}}</p-tab>
            </p-tablist>
            <p-tabpanels [ngClass]="{'tsusho-tab-panel': !isNyuSho && !isShortTimeSettingDialog, 'short-time-tab-panel': isShortTimeSettingDialog, 'functional-training-tab-panel': isFunctionalTrainingSettingDialog}">
                <p-tabpanel *ngIf="isNyuSho" value="0">
                    <div class="nyusho-container">
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.SORT_ORDER}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item" 
                                    [attr.dpad]="DpadZoneType.DIALOG" 
                                    [attr.x-tab-dpad]="0" 
                                    [attr.y-tab-dpad]="1"
                                    [attr.scale-dpad]="1.02" 
                                    [attr.tab-dpad]="1" 
                                    (click)="onNyuShoRadioClick('sortRoom')">
                                    <caremoni-radio-button 
                                    [isChecked]="isSortByRoom"
                                    [disabled]="false">
                                    </caremoni-radio-button>
                                    <label for="rdSortRoom" [ngClass]="{'disabled': false}" class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.SORT_ROOM_NYUSHO}}</label>
                                </div>
                                <div class="nyusho-item" 
                                    [attr.dpad]="DpadZoneType.DIALOG" 
                                    [attr.x-tab-dpad]="1" 
                                    [attr.y-tab-dpad]="1"
                                    [attr.scale-dpad]="1.02" 
                                    [attr.tab-dpad]="1" 
                                    (click)="onNyuShoRadioClick('sortName')">
                                    <caremoni-radio-button 
                                    [isChecked]="isSortByName"
                                    [disabled]="false">
                                    </caremoni-radio-button>
                                    <label for="rdSortName" [ngClass]="{'disabled': false}" class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.TIME_RANGE_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-select-box 
                                        class="time-range-select"
                                        [dpad]="DpadZoneType.DIALOG" 
                                        [xtabdpad]="0" 
                                        [ytabdpad]="2" 
                                        [scaledpad]="1.02"
                                        [tabdpad]="1" 
                                        [options]="timeRanges" 
                                        [selectedValue]="timeRangeSelected" 
                                        (valueChange)="onChangeTimeRange($event)">
                                    </caremoni-select-box>
                                    <label [ngClass]="{'disabled': false}" class="nyusho-lbl">時間</label>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        [dpad]="DpadZoneType.DIALOG" 
                                        [xtabdpad]="0" 
                                        [ytabdpad]="4" 
                                        [scaledpad]="1.02"
                                        [tabdpad]="1" 
                                        class="unit-select"
                                        [options]="displayUnits" 
                                        [selectedValues]="unitSelected" 
                                        (valueChange)="onChangeUnit($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        [dpad]="DpadZoneType.DIALOG" 
                                        [xtabdpad]="0" 
                                        [ytabdpad]="5" 
                                        [scaledpad]="1.02"
                                        [tabdpad]="1" 
                                        class="unit-select"
                                        [options]="displayGroups" 
                                        [selectedValues]="groupSelected" 
                                        (valueChange)="onChangeGroup($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                  <div modal-bottom *ngIf="dialogTemplate.hasBottom" class = "button-confirm">
                    <div class="d-flex justify-content-center">
                      <button [attr.dpad]="DpadZoneType.DIALOG" [attr.x-tab-dpad]="0" [attr.y-tab-dpad]="6"
                        [attr.scale-dpad]="1.02" [attr.tab-dpad]="1" class="button-bottom" (click)="onSubmit()" tabindex="40">
                        {{CHECKSHEETSETTINGDIALOG.BTN_CONFIRM}}
                      </button>
                    </div>
                    </div>
                </p-tabpanel>
                <p-tabpanel *ngIf="!isNyuSho" value="0">
                    <div *ngIf="isShortTimeSettingDialog" class="tsusho-sort-order-row">
                        <label class="tsusho-sort-order-title">
                            {{CHECKSHEETSETTINGDIALOG.DISPLAY_ORDER}}
                        </label>
                        <div class="tsusho-sort-order-action">
                            <div class="tsusho-sort-order-item"
                                [attr.dpad]="DpadZoneType.DIALOG"
                                [attr.x-tab-dpad]="0"
                                [attr.y-tab-dpad]="1"
                                [attr.scale-dpad]="1.02"
                                [attr.tab-dpad]="1"
                                (click)="onDisplayOrderClick(displayOrder.name)"
                                tabindex="7">
                                <caremoni-radio-button
                                    [isChecked]="isDisplayOrderSelected(displayOrder.name)"
                                    [disabled]="false">
                                </caremoni-radio-button>
                                <label [ngClass]="{'disabled': false}" class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
                            </div>
                            <div class="tsusho-sort-order-item"
                                [attr.dpad]="DpadZoneType.DIALOG"
                                [attr.x-tab-dpad]="1"
                                [attr.y-tab-dpad]="1"
                                [attr.scale-dpad]="1.02"
                                [attr.tab-dpad]="1"
                                (click)="onDisplayOrderClick(displayOrder.startTime)"
                                tabindex="8">
                                <caremoni-radio-button
                                    [isChecked]="isDisplayOrderSelected(displayOrder.startTime)"
                                    [disabled]="false">
                                </caremoni-radio-button>
                                <label [ngClass]="{'disabled': false}" class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.START_TIME_ORDER}}</label>
                            </div>
                            <div class="tsusho-sort-order-item"
                                [attr.dpad]="DpadZoneType.DIALOG"
                                [attr.x-tab-dpad]="2"
                                [attr.y-tab-dpad]="1"
                                [attr.scale-dpad]="1.02"
                                [attr.tab-dpad]="1"
                                (click)="onDisplayOrderClick(displayOrder.endTime)"
                                tabindex="9">
                                <caremoni-radio-button
                                    [isChecked]="isDisplayOrderSelected(displayOrder.endTime)"
                                    [disabled]="false">
                                </caremoni-radio-button>
                                <label [ngClass]="{'disabled': false}" class="nyusho-lbl">{{CHECKSHEETSETTINGDIALOG.END_TIME_ORDER}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex content-width" (click)="onCheckboxClick(SortType.hidden_overtime_flg)" [attr.tabindex]="isShortTimeSettingDialog ? 10 : 7">
                        <caremoni-checkbox 
                            [value]="this.currentConfig.hidden_overtime_flg"></caremoni-checkbox>
                        <label for="checkbox1" class="ml-4 dlgu-txt pd-bot-5">{{CHECKSHEETSETTINGDIALOG.HIDE_USERS_OUTSIDE}}</label>
                    </div>
                    <div class="d-flex content-width" (click)="onCheckboxClick(SortType.hidden_leave_user)" [attr.tabindex]="isShortTimeSettingDialog ? 11 : 8">
                        <caremoni-checkbox 
                            [value]="this.currentConfig.hidden_leave_user"></caremoni-checkbox>
                        <label for="checkbox2" class="ml-4 dlgu-txt">{{CHECKSHEETSETTINGDIALOG.HIDE_USERS_LEAVE}}</label>
                    </div>
                    <div class="setting-config">
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        class="unit-select"
                                        [options]="displayUnits" 
                                        [selectedValues]="unitSelected" 
                                        (valueChange)="onChangeUnit($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                        <div class="nyusho-row">
                            <label class="nyusho-title">
                                {{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}
                            </label>
                            <div class="nyusho-action">
                                <div class="nyusho-item">
                                    <caremoni-multi-select-box 
                                        class="unit-select"
                                        [options]="displayGroups" 
                                        [selectedValues]="groupSelected" 
                                        (valueChange)="onChangeGroup($event)">
                                    </caremoni-multi-select-box>
                                </div>
                            </div>
                        </div>
                  </div>
                  <div modal-bottom *ngIf="dialogTemplate.hasBottom" class = "button-confirm">
                    <div class="d-flex justify-content-center  button-confirm`">
                      <button [attr.dpad]="DpadZoneType.DIALOG" [attr.x-tab-dpad]="0" [attr.y-tab-dpad]="isNyuSho || isShortTimeSettingDialog ? 6 : 5"
                        [attr.scale-dpad]="1.02" [attr.tab-dpad]="1" class="button-bottom" (click)="onSubmit()" tabindex="40">
                        {{CHECKSHEETSETTINGDIALOG.BTN_CONFIRM}}
                      </button>
                    </div>
                  </div>
                </p-tabpanel>
                <p-tabpanel value="1">
                    <div class="grid" [ngClass]="{'tab-header-nyusho': isNyuSho, 'tab-header-functional-training': isFunctionalTrainingSettingDialog}" [ngStyle]="{'grid-template-columns': gridColumns, 'grid-template-rows': gridRows}">
                        <div *ngFor="let header of currentHeaders; let i = index">
                          <label class="lbl-margin">{{ header.headerName }}</label>
                          <caremoni-switch-button [dpad]="DpadZoneType.DIALOG" [xtabdpad]="i%3" [ytabdpad]="getYTabDpad(i) + 1" [scaledpad]="1.02" [tabdpad]="2" *ngIf="header.headerName" [checked]="header.visible" (onClick)="onChangeHeaderColumns(header)"></caremoni-switch-button>
                </div>
              </div>
                  <div modal-bottom *ngIf="dialogTemplate.hasBottom" class = "button-confirm">
                    <div class="d-flex justify-content-center button-confirm" >
                      <button [attr.dpad]="DpadZoneType.DIALOG" [attr.x-tab-dpad]="0" [attr.y-tab-dpad]="getYTabDpad(currentHeaders.length) + 1"
                        [attr.scale-dpad]="1.02" [attr.tab-dpad]="2" class="button-bottom" (click)="onSubmit()" tabindex="40">
                        {{CHECKSHEETSETTINGDIALOG.BTN_CONFIRM}}
                      </button>
                    </div>
                  </div>
                </p-tabpanel>
                <p-tabpanel value="2">
                    <div class="setting-config config-tab">
                        <div class="display-row">
                            <div class="filter-content">
                                <label>{{CHECKSHEETSETTINGDIALOG.TIME_CHANGE_PAGE}}</label>
                                <div class="option-group">
                                    <caremoni-textbox class="input-unit"
                                        [dpad]="DpadZoneType.DIALOG"
                                        [xtabdpad]="0"
                                        [ytabdpad]="1"
                                        [scaledpad]="1.02"
                                        [tabdpad]="3"
                                        [canClear]="false" [inputValue]="timeChangePage"
                                        [inputParams]="inputParams" (onKeyDown)="onInputKeyDown($event)"
                                        (focusout)="onFocusOutInput($event)" (inputValueChange)="onChangeSettingTime($event)">
                                    </caremoni-textbox>
                                    <label class="option-label">秒</label>
                      </div>
                    </div>
                  </div>
                  <div class="single-config">
                    <div class="filter-content">
                      <label>{{CHECKSHEETSETTINGDIALOG.MARQUEE_SPEED}}</label>
                      <div class="option-group">
                        <caremoni-select-box class="marquee-speed-select"
                            [dpad]="DpadZoneType.DIALOG"
                            [xtabdpad]="0"
                            [ytabdpad]="2"
                            [scaledpad]="1.02"
                            [tabdpad]="3"
                            [options]="marqueeSpeedOptions"
                            [selectedValue]="marqueeSpeedRate"
                            (valueChange)="onChangeMarqueeSpeed($event)">
                        </caremoni-select-box>
                      </div>
                    </div>
                  </div>
                  <div class="single-config">
                    <div class="filter-content">
                      <label>{{CHECKSHEETSETTINGDIALOG.FLASHING_SWITCHING}}</label>
                      <div class="option-group">
                        <caremoni-switch-button
                            [dpad]="DpadZoneType.DIALOG"
                            [xtabdpad]="0"
                            [ytabdpad]="3"
                            [scaledpad]="1.02"
                            [tabdpad]="3"
                            [checked]="isFlashingMoshiokuri"
                            (onClick)="onChangeFlashingType()">
                        </caremoni-switch-button>
                      </div>
                    </div>
                  </div>
                </div>
              <div modal-bottom *ngIf="dialogTemplate.hasBottom" class = "button-confirm">
                <div class="d-flex justify-content-center">
                  <button [attr.dpad]="DpadZoneType.DIALOG" [attr.x-tab-dpad]="0" [attr.y-tab-dpad]="4"
                    [attr.scale-dpad]="1.02" [attr.tab-dpad]="3" class="button-bottom" (click)="onSubmit()" tabindex="40">
                    {{CHECKSHEETSETTINGDIALOG.BTN_CONFIRM}}
                  </button>
                </div>
              </div>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>


</caremoni-dialog-template>
